import {OS, resolveSupportedOS} from '@github-ui/get-os'

export function resolveDesktopOS(detectedOS: OS): Extract<OS, 'macOS' | 'Windows' | 'Linux'> {
  return resolveSupportedOS(detectedOS, [OS.macOS, OS.Windows, OS.Linux])
}

export function resolveShowcaseOS(detectedOS: OS): Extract<OS, 'macOS' | 'Windows'> {
  return resolveDesktopOS(detectedOS) === OS.macOS ? OS.macOS : OS.Windows
}
